import { Type } from 'class-transformer';
import {
  IsBoolean,
  IsEmail,
  IsEnum,
  IsOptional,
  IsString,
  ValidateIf,
  ValidateNested,
} from 'class-validator';
import { PropertySellerRole } from './property-enums';

export class PropertySellerBeneficiaryDto {
  // Pour "family" (Personne physique / proche)
  @IsOptional()
  @IsString()
  firstName?: string;

  @IsOptional()
  @IsString()
  lastName?: string;

  @IsOptional()
  @ValidateIf((o) => typeof o.email === 'string' && o.email.trim().length > 0)
  @IsEmail()
  email?: string;

  @IsOptional()
  @IsString()
  phone?: string;

  // Pour "company" (Personne morale / SCI / Société)
  @IsOptional()
  @IsString()
  companyName?: string;

  @IsOptional()
  @IsString()
  siren?: string;

  // Pour "estate_heir" (Succession / Indivision)
  @IsOptional()
  @IsString()
  estateName?: string;

  @IsOptional()
  @IsString()
  notaryName?: string;
}

export class PropertySellerDto {
  @IsEnum(PropertySellerRole)
  role: PropertySellerRole = PropertySellerRole.OWNER;

  @IsOptional()
  @ValidateIf((o) => o.role !== PropertySellerRole.OWNER && !!o.beneficiary)
  @ValidateNested()
  @Type(() => PropertySellerBeneficiaryDto)
  beneficiary?: PropertySellerBeneficiaryDto;

  @IsOptional()
  @IsString()
  representationDetails?: string;

  @IsOptional()
  @IsBoolean()
  hasOwnerConsent?: boolean = true;
}
